import React from 'react';

export default function SectionHeading({
    eyebrow,
    title,
    description,
    align = 'left',
    onDark = false,
}) {
    const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
    const titleColor = onDark ? 'text-white' : 'text-brand-navy';
    const descColor = onDark ? 'text-white/75' : 'text-brand-navy/70';
    return (
        <div className={`max-w-3xl ${alignment}`}>
            {eyebrow && (
                <div className={`text-xs md:text-sm uppercase tracking-[0.3em] font-bold text-brand-orange mb-4`}>
                    {eyebrow}
                </div>
            )}
            <h2 className={`font-display font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-[44px] xl:text-[52px] tracking-tight leading-[1.02] ${titleColor}`}>
                {title}
            </h2>
            {description && (
                <p className={`text-base md:text-lg leading-relaxed mt-4 md:mt-5 max-w-2xl ${descColor}`}>
                    {description}
                </p>
            )}
        </div>
    );
}
